import { createWithEqualityFn } from 'zustand/traditional';
import { getAllFonts, getFontsByOffset } from '../services/Fonts';

const useFontsDataStore = createWithEqualityFn<any>(set => ({
  fontsData: {
    data: [],
    isFilter: false,
    offset: 0,
    landingsDataCount: 0,
  },
  isLoading: true,

  fetchFontsData: async () => {
    set({ isLoading: true });

    const { offset } = useFontsDataStore.getState().fontsData;

    try {
      const fontsData = await getAllFonts(offset);
      const updatedFontsData = {
        ...useFontsDataStore.getState().fontsData,
        data: [...useFontsDataStore.getState().fontsData.data, ...fontsData.response],
        landingsDataCount: fontsData.response.length,
        offset: offset + 1,
        isFilter: false,
      };

      set({ fontsData: updatedFontsData, isLoading: false });
    } catch (error) {
      console.error('Error fetching fonts data:', error);
      set({ isLoading: false });
    }
  },

  searchFonts: async (searchParams: string, isPaid: boolean, reset: boolean) => {
    set({ isLoading: true });

    const { offset } = useFontsDataStore.getState().fontsData;
    const newOffset = reset ? 0 : offset;

    try {
      const fontsData = await getFontsByOffset(isPaid, newOffset, searchParams);

      set({
        fontsData: {
          ...useFontsDataStore.getState().fontsData,
          data: reset
            ? fontsData.response
            : [...useFontsDataStore.getState().fontsData.data, ...fontsData.response],
          landingsDataCount: fontsData.response.length,
          offset: newOffset + 1,
          isFilter: true,
        },
        isLoading: false,
      });
    } catch (error) {
      console.error('Error fetching fonts:', error);
      set({ isLoading: false });
    }
  },
}));

export default useFontsDataStore;
